import { DatePipe, formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'injectHyperlink'
})
export class InjectHyperlinkPipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  transform(value: string, hyperlink: string, target: '_blank'|'_self'|'_parent'|'_top' = '_self'): any {

    if (value) {
      var text = value.substring(value.indexOf('[[') + 2, value.indexOf(']]'));
      var begin = value.substring(0, value.indexOf('[['));

      if (value.indexOf(']]') + 2 < value.length) {
        var end = value.substring(value.indexOf(']]') + 2, value.length);
      }
      return this.sanitizer.bypassSecurityTrustHtml(`${begin}<a target='${target}' href='${hyperlink}'>${text}</a>${end ? end : ''}`);
    }
  }
}
